import React from "react";
import axios from "axios";
import { useState, useEffect, useRef } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";

import Snackbar from "@mui/material/Snackbar";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";



const apiUrl = process.env.REACT_APP_API_URL;

export const AjoutContrat = ({ setAjoutContrat }) => {

  const [search, setSearch] = useState("");
  const [etatInput, setEtatInput] = useState(true);
  const [idClient, setIdClient] = useState("");
  const [nomClient, setNomClient] = useState("");
  const [idLocation, setIdLocation] = useState("");
  const [idStockage, setIdStockage] = useState("");
  const [vol, setVol] = useState("");
  const [loyer, setLoyer] = useState("");
  const [mail, setMail] = useState("");
  const [num, setNum] = useState("");
  const [adresse, setAdresse] = useState("");
  const [dateResrv, setDateResrv] = useState("");
  const [dateEntree, setDateEntree] = useState("");

  // Contrat 1
  const [typeContrat, setTypeContrat] = useState("");
  const [typeCaution, setTypeCaution] = useState("");
  const [lienContrat, setLienContrat] = useState("");
  const [dateCtr, setDateCtr] = useState("");
  const [noteContrat, setNoteContrat] = useState("");

  // Contrat 2
  const [hasSecondContrat, setHasSecondContrat] = useState(false);
  const [lienContrat2, setLienContrat2] = useState("");
  const [dateCtr2, setDateCtr2] = useState("");

  const searchTextFieldRef = useRef(null);

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [message, setMessage] = useState("");


  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      chercherLoc();
    }
  };

  const chercherLoc = () => {
    if (/^\s*$/.test(search)) {
      viderChamp();
    } else {
      axios
        .post(`${apiUrl}IHM/api/?search=${search}`)
        .then((response) => {
          const data = response.data[0];
          setNomClient(data.nom);
          setIdClient(data.idClient);
          setAdresse(`${data.ville} - ${data.codePostal} - ${data.adresse}`);
          setNum(`${data.num1} - ${data.num2}`);
          setMail(`${data.mail} - ${data.mail2}`);
          infoLocation(data.idClient);
        })
        .catch((error) => {
          console.error("Erreur:", error);
          setMessage("Client non trouvé");
          setOpenSnackbar(true);
        });
    }
  };

  const infoLocation = (idCli) => {
    axios
      .post(`${apiUrl}IHM/api/paiement.php?idCli=${idCli}`)
      .then((response) => {
        setEtatInput(false);
        const data = response.data[0];
        setIdLocation(data.idLocation);
        setVol(data.totVolume);
        setLoyer(data.loyer);
        setIdStockage(data.idStockage);
        setDateEntree(data.dateEntree);
        setDateResrv(data.dateReservation);
      })
      .catch((error) => {
        setEtatInput(true);
        setMessage("Ce client n'a pas de location en cours");
        setOpenSnackbar(true);
      });
  };

  const viderChamp = () => {
    setEtatInput(true);
    setIdLocation("");
    setLoyer("");
    setMail("");
    setNomClient("");
    setIdClient("");
    setIdStockage("");
    setAdresse("");
    setDateResrv("");
    setNoteContrat("");
    setNum("");
    setVol("");
  };

  const ajoutReglem = async (e) => {
    e.preventDefault();

    if (typeContrat === "") {

      return;
    }

    if (idClient === "") {
      
      return;
    }

    const dataContrat = {
      idLocation: idLocation,
      idStockage: idStockage,
      typeCtr: typeContrat,
      caution: typeCaution,
      dateCtr: dateCtr || new Date().toISOString().split('T')[0],
      idClient: idClient,
      noteCtr: noteContrat,
      lienCtr: lienContrat,
      lienCtr2: hasSecondContrat ? lienContrat2 : null,
      dateContrat2: hasSecondContrat ? dateCtr2 : null,
    };

    try {
      await axios.put(`${apiUrl}IHM/api/contrat.php`, dataContrat);
      

      setEtatInput(true);
      setMessage("Le contrat a été ajouté");
      setOpenSnackbar(true);

      setTimeout(() => {
        setAjoutContrat(false);
        // window.location.reload();
      }, 1500);
    } catch (error) {
      console.error("Erreur:", error);
    }
  };

  useEffect(() => {
    if (searchTextFieldRef.current) {
      searchTextFieldRef.current.focus();
    }
  }, []);

  const header = (
    <div className="flex justify-content-between align-items-center w-full">
      <span className="font-semibold text-lg">Ajouter un contrat</span>
    </div>
  );

  const handleCloseSnackbar = () => {
    setMessage("");
    setOpenSnackbar(false);
  };

  return (
    <>
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        open={openSnackbar}
        autoHideDuration={1000}
        onClose={handleCloseSnackbar}
        message={message}
        action={
          <React.Fragment>
            <IconButton
              size="small"
              aria-label="close"
              color="inherit"
              onClick={handleCloseSnackbar}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </React.Fragment>
        }
      />

      <Dialog
        blockScroll
        visible={true}
        header={header}
        className="custom-dialog"
        style={{ width: "50vw", maxWidth: "700px" }}
        modal
        onHide={() => setAjoutContrat(false)}
        breakpoints={{ "960px": "90vw", "640px": "95vw" }}
      >
        <div className="p-3">
          {/* Section 1 - Recherche client */}
          <div className="grid">
            <div className="col-12">
              <div
                style={{
                  background: "#f3f4f6",
                  padding: "4px 8px",
                  borderRadius: "4px",
                  marginBottom: "10px",
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                }}
              >
                <span
                  style={{
                    background: "#374151",
                    color: "white",
                    borderRadius: "50%",
                    width: "18px",
                    height: "18px",
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "11px",
                    fontWeight: 700,
                  }}
                >
                  1
                </span>
                <span
                  style={{
                    fontSize: "11px",
                    fontWeight: 600,
                    color: "#374151",
                    letterSpacing: "0.05em",
                  }}
                >
                  RECHERCHER UN CLIENT
                </span>
              </div>
            </div>
          </div>

          <div className="grid">
            <div className="col-12">
              <div
                style={{ display: "flex", gap: "8px", alignItems: "center" }}
              >
                <input
                  ref={searchTextFieldRef}
                  value={search}
                  onChange={(e) => {
                    setSearch(e.target.value);
                    viderChamp();
                  }}
                  onKeyDown={handleKeyDown}
                  placeholder="Adresse mail / numéro / nom..."
                  style={{
                    flex: 1,
                    height: "36px",
                    padding: "0 8px",
                    border: "1px solid #d1d5db",
                    borderRadius: "5px",
                    fontSize: "14px",
                  }}
                />
                <button
                  onClick={chercherLoc}
                  style={{
                    height: "36px",
                    padding: "0 16px",
                    border: "none",
                    borderRadius: "5px",
                    background: "#2563eb",
                    color: "white",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                  }}
                >
                  <i className="pi pi-search" />
                  Rechercher
                </button>
              </div>
            </div>
          </div>

          {/* Section 2 - Informations client */}
          {nomClient && (
            <>
              <div className="grid mt-3">
                <div className="col-12">
                  <div
                    style={{
                      background: "#f3f4f6",
                      padding: "4px 8px",
                      borderRadius: "4px",
                      marginBottom: "10px",
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                    }}
                  >
                    <span
                      style={{
                        background: "#374151",
                        color: "white",
                        borderRadius: "50%",
                        width: "18px",
                        height: "18px",
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "11px",
                        fontWeight: 700,
                      }}
                    >
                      2
                    </span>
                    <span
                      style={{
                        fontSize: "11px",
                        fontWeight: 600,
                        color: "#374151",
                        letterSpacing: "0.05em",
                      }}
                    >
                      INFORMATIONS CLIENT
                    </span>
                  </div>
                </div>
              </div>

              <div className="grid">
                <div className="col-12 md:col-6">
                  <label
                    style={{
                      fontSize: "12px",
                      color: "#374151",
                      display: "block",
                      marginBottom: "2px",
                    }}
                  >
                    Client
                  </label>
                  <input
                    value={`${idClient} - ${nomClient}`}
                    disabled
                    style={{
                      width: "100%",
                      height: "36px",
                      padding: "0 8px",
                      border: "1px solid #d1d5db",
                      borderRadius: "5px",
                      background: "#f9fafb",
                      fontSize: "14px",
                    }}
                  />
                </div>
                <div className="col-12 md:col-6">
                  <label
                    style={{
                      fontSize: "12px",
                      color: "#374151",
                      display: "block",
                      marginBottom: "2px",
                    }}
                  >
                    Box
                  </label>
                  <input
                    value={idStockage}
                    disabled
                    style={{
                      width: "100%",
                      height: "36px",
                      padding: "0 8px",
                      border: "1px solid #d1d5db",
                      borderRadius: "5px",
                      background: "#f9fafb",
                      fontSize: "14px",
                    }}
                  />
                </div>
              </div>

              <div className="grid">
                <div className="col-12 md:col-4">
                  <label
                    style={{
                      fontSize: "12px",
                      color: "#374151",
                      display: "block",
                      marginBottom: "2px",
                    }}
                  >
                    Email
                  </label>
                  <input
                    value={mail}
                    disabled
                    style={{
                      width: "100%",
                      height: "36px",
                      padding: "0 8px",
                      border: "1px solid #d1d5db",
                      borderRadius: "5px",
                      background: "#f9fafb",
                      fontSize: "14px",
                    }}
                  />
                </div>
                <div className="col-12 md:col-4">
                  <label
                    style={{
                      fontSize: "12px",
                      color: "#374151",
                      display: "block",
                      marginBottom: "2px",
                    }}
                  >
                    Téléphone
                  </label>
                  <input
                    value={num}
                    disabled
                    style={{
                      width: "100%",
                      height: "36px",
                      padding: "0 8px",
                      border: "1px solid #d1d5db",
                      borderRadius: "5px",
                      background: "#f9fafb",
                      fontSize: "14px",
                    }}
                  />
                </div>
                <div className="col-12 md:col-4">
                  <label
                    style={{
                      fontSize: "12px",
                      color: "#374151",
                      display: "block",
                      marginBottom: "2px",
                    }}
                  >
                    Loyer mensuel
                  </label>
                  <input
                    value={`${loyer} €`}
                    disabled
                    style={{
                      width: "100%",
                      height: "36px",
                      padding: "0 8px",
                      border: "1px solid #d1d5db",
                      borderRadius: "5px",
                      background: "#f9fafb",
                      fontSize: "14px",
                    }}
                  />
                </div>
              </div>

              <div className="grid">
                <div className="col-12">
                  <label
                    style={{
                      fontSize: "12px",
                      color: "#374151",
                      display: "block",
                      marginBottom: "2px",
                    }}
                  >
                    Adresse
                  </label>
                  <input
                    value={adresse}
                    disabled
                    style={{
                      width: "100%",
                      height: "36px",
                      padding: "0 8px",
                      border: "1px solid #d1d5db",
                      borderRadius: "5px",
                      background: "#f9fafb",
                      fontSize: "14px",
                    }}
                  />
                </div>
              </div>

              {/* Section 3 - Contrat principal */}
              <div className="grid mt-3">
                <div className="col-12">
                  <div
                    style={{
                      background: "#f3f4f6",
                      padding: "4px 8px",
                      borderRadius: "4px",
                      marginBottom: "10px",
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                    }}
                  >
                    <span
                      style={{
                        background: "#374151",
                        color: "white",
                        borderRadius: "50%",
                        width: "18px",
                        height: "18px",
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "11px",
                        fontWeight: 700,
                      }}
                    >
                      3
                    </span>
                    <span
                      style={{
                        fontSize: "11px",
                        fontWeight: 600,
                        color: "#374151",
                        letterSpacing: "0.05em",
                      }}
                    >
                      CONTRAT PRINCIPAL
                    </span>
                  </div>
                </div>
              </div>

              <div className="grid">
                <div className="col-12 md:col-6">
                  <label
                    style={{
                      fontSize: "12px",
                      color: "#374151",
                      display: "block",
                      marginBottom: "2px",
                    }}
                  >
                    Type de contrat
                  </label>
                  <select
                    value={typeContrat}
                    onChange={(e) => setTypeContrat(e.target.value)}
                    disabled={etatInput}
                    style={{
                      width: "100%",
                      height: "36px",
                      padding: "0 8px",
                      border: "1px solid #d1d5db",
                      borderRadius: "5px",
                      fontSize: "13px",
                      background: "white",
                    }}
                  >
                    <option value="">Sélectionner</option>
                    <option value="CNS">Contrat non signé (CNS)</option>
                    <option value="CS">Contrat signé (CS)</option>
                    <option value="CE">Contrat envoyé (CE)</option>
                    <option value="PDC">Pas de contrat (PDC)</option>
                  </select>
                </div>
                <div className="col-12 md:col-6">
                  <label
                    style={{
                      fontSize: "12px",
                      color: "#374151",
                      display: "block",
                      marginBottom: "2px",
                    }}
                  >
                    Caution / docs
                  </label>
                  <select
                    value={typeCaution}
                    onChange={(e) => setTypeCaution(e.target.value)}
                    disabled={etatInput}
                    style={{
                      width: "100%",
                      height: "36px",
                      padding: "0 8px",
                      border: "1px solid #d1d5db",
                      borderRadius: "5px",
                      fontSize: "13px",
                      background: "white",
                    }}
                  >
                    <option value="">Sélectionner</option>
                    <option value="oui">Oui</option>
                    <option value="non">Non</option>
                  </select>
                </div>
              </div>

              <div className="grid">
                <div className="col-12 md:col-6">
                  <label
                    style={{
                      fontSize: "12px",
                      color: "#374151",
                      display: "block",
                      marginBottom: "2px",
                    }}
                  >
                    Lien du contrat
                  </label>
                  <input
                    value={lienContrat}
                    onChange={(e) => {
                      setLienContrat(e.target.value);
                      if (e.target.value.includes("https://drive")) {
                        setTypeContrat("CS");
                      }
                    }}
                    placeholder="https://..."
                    disabled={etatInput}
                    style={{
                      width: "100%",
                      height: "36px",
                      padding: "0 8px",
                      border: "1px solid #d1d5db",
                      borderRadius: "5px",
                      fontSize: "14px",
                    }}
                  />
                </div>
                <div className="col-12 md:col-6">
                  <label
                    style={{
                      fontSize: "12px",
                      color: "#374151",
                      display: "block",
                      marginBottom: "2px",
                    }}
                  >
                    Date du contrat
                  </label>
                  <input
                    type="date"
                    value={dateCtr}
                    onChange={(e) => setDateCtr(e.target.value)}
                    disabled={etatInput}
                    style={{
                      width: "100%",
                      height: "36px",
                      padding: "0 8px",
                      border: "1px solid #d1d5db",
                      borderRadius: "5px",
                      fontSize: "14px",
                    }}
                  />
                </div>
              </div>

              <div className="grid">
                <div className="col-12">
                  <label
                    style={{
                      fontSize: "12px",
                      color: "#374151",
                      display: "block",
                      marginBottom: "2px",
                    }}
                  >
                    Note
                  </label>
                  <textarea
                    value={noteContrat}
                    onChange={(e) => setNoteContrat(e.target.value)}
                    rows={2}
                    disabled={etatInput}
                    style={{
                      width: "100%",
                      padding: "8px",
                      border: "1px solid #d1d5db",
                      borderRadius: "5px",
                      fontSize: "14px",
                      fontFamily: "inherit",
                      resize: "vertical",
                    }}
                  />
                </div>
              </div>

              {/* Section 4 - Contrat secondaire */}
              <div className="grid mt-3">
                <div className="col-12">
                  {!hasSecondContrat ? (
                    <button
                      onClick={() => setHasSecondContrat(true)}
                      disabled={etatInput}
                      style={{
                        width: "100%",
                        padding: "10px",
                        border: "1px dashed #d1d5db",
                        borderRadius: "5px",
                        background: "transparent",
                        fontSize: "14px",
                        color: "#374151",
                        cursor: etatInput ? "not-allowed" : "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "8px",
                        opacity: etatInput ? 0.5 : 1,
                      }}
                    >
                      <span style={{ fontSize: "20px" }}>+</span> Ajouter un
                      deuxième contrat
                    </button>
                  ) : (
                    <>
                      <div
                        style={{
                          background: "#f3f4f6",
                          padding: "4px 8px",
                          borderRadius: "4px",
                          marginBottom: "10px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "6px",
                          }}
                        >
                          <span
                            style={{
                              background: "#374151",
                              color: "white",
                              borderRadius: "50%",
                              width: "18px",
                              height: "18px",
                              display: "inline-flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontSize: "11px",
                              fontWeight: 700,
                            }}
                          >
                            4
                          </span>
                          <span
                            style={{
                              fontSize: "11px",
                              fontWeight: 600,
                              color: "#374151",
                              letterSpacing: "0.05em",
                            }}
                          >
                            CONTRAT SECONDAIRE
                          </span>
                        </div>
                        <button
                          onClick={() => {
                            setHasSecondContrat(false);
                            setLienContrat2("");
                            setDateCtr2("");
                          }}
                          style={{
                            border: "none",
                            background: "transparent",
                            color: "#ef4444",
                            cursor: "pointer",
                            fontSize: "16px",
                          }}
                        >
                          ✕
                        </button>
                      </div>

                      <div className="grid">
                        <div className="col-12 md:col-6">
                          <label
                            style={{
                              fontSize: "12px",
                              color: "#374151",
                              display: "block",
                              marginBottom: "2px",
                            }}
                          >
                            Lien du contrat 2
                          </label>
                          <input
                            value={lienContrat2}
                            onChange={(e) => setLienContrat2(e.target.value)}
                            placeholder="https://..."
                            disabled={etatInput}
                            style={{
                              width: "100%",
                              height: "36px",
                              padding: "0 8px",
                              border: "1px solid #d1d5db",
                              borderRadius: "5px",
                              fontSize: "14px",
                            }}
                          />
                        </div>
                        <div className="col-12 md:col-6">
                          <label
                            style={{
                              fontSize: "12px",
                              color: "#374151",
                              display: "block",
                              marginBottom: "2px",
                            }}
                          >
                            Date du contrat 2
                          </label>
                          <input
                            type="date"
                            value={dateCtr2}
                            onChange={(e) => setDateCtr2(e.target.value)}
                            disabled={etatInput}
                            style={{
                              width: "100%",
                              height: "36px",
                              padding: "0 8px",
                              border: "1px solid #d1d5db",
                              borderRadius: "5px",
                              fontSize: "14px",
                            }}
                          />
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>

              {/* Bouton enregistrer */}
              <div className="grid mt-3">
                <div className="col-12">
                  <Button
                    label="Ajouter le contrat"
                    icon="pi pi-check"
                    className="w-full"
                    style={{
                      background: "#0971b7",
                      border: "none",
                      padding: "0.75rem",
                      borderRadius: "6px",
                      fontSize: "14px",
                      fontWeight: 500,
                      justifyContent: "center",
                      gap: "8px",
                      color: "white",
                    }}
                    onClick={ajoutReglem}
                    disabled={etatInput}
                  />
                </div>
              </div>
            </>
          )}
        </div>
      </Dialog>
    </>
  );
};